import { useMemo, useState, useCallback } from 'react'

export type QueuedMsg = {
  id: string
  priority: number // higher = sooner
  render: (controls: { close: () => void }) => React.ReactNode
}

export const useInfoQueue = (initial: QueuedMsg[] = []) => {
  const [items, setItems] = useState<QueuedMsg[]>(initial)
  const enqueue = useCallback((item: QueuedMsg) => setItems(prev => [...prev, item]), [])
  const closeById = useCallback((id: string) => setItems(prev => prev.filter(i => i.id !== id)), [])
  const current = useMemo(() => items.slice().sort((a, b) => b.priority - a.priority)[0], [items])
  return { enqueue, closeById, current, hasPending: items.length > 0 }
}